import { useState } from 'react';
import { api } from '../api.js';
import { inputToCents } from '../format.js';
import { useApp } from '../state.js';

/** Primer arranque sin hogar: crear el hogar con un paso explícito (no se inventa saldo previo). */
export function SetupPage() {
  const { refresh, toast } = useApp();
  const [form, setForm] = useState({ name: 'Nuestro hogar', persons: 'Mariano, Mariana', openingPeriod: new Date().toISOString().slice(0, 7), openingBalance: '0,00' });
  const [error, setError] = useState<string | null>(null);
  async function create() {
    const cents = inputToCents(form.openingBalance);
    if (cents === null) return setError('Acumulado inicial inválido.');
    try {
      await api.createHousehold({ name: form.name.trim(), openingPeriod: form.openingPeriod, openingBalanceCents: cents, persons: form.persons.split(',').map((s) => s.trim()).filter(Boolean) });
      toast('Hogar creado');
      await refresh();
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Error');
    }
  }
  return (
    <div className="page" style={{ maxWidth: 640, margin: '40px auto' }}>
      <div className="panel">
        <div className="eyebrow">Primer arranque</div>
        <h2>Configurar el hogar</h2>
        <p className="muted">No hay datos todavía. Indicá el punto de partida del acumulado; después podrás crear conceptos e ingresos. Para datos de ejemplo ejecutá <code>npm run db:seed</code>.</p>
        <label>
          Nombre del hogar
          <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        </label>
        <label>
          Personas (separadas por coma)
          <input value={form.persons} onChange={(e) => setForm({ ...form, persons: e.target.value })} />
        </label>
        <div className="field-row">
          <label>
            Primer mes con acumulado conocido (YYYY-MM)
            <input value={form.openingPeriod} onChange={(e) => setForm({ ...form, openingPeriod: e.target.value })} />
          </label>
          <label>
            Acumulado al inicio de ese mes (€)
            <input inputMode="decimal" value={form.openingBalance} onChange={(e) => setForm({ ...form, openingBalance: e.target.value })} />
          </label>
        </div>
        {error ? <div className="error">{error}</div> : null}
        <button type="button" className="button primary" onClick={() => void create()}>
          Crear hogar
        </button>
      </div>
    </div>
  );
}

/** Acceso privado del hogar cuando BALANCE_PASSWORD está configurada. */
export function LoginPage() {
  const { refresh, auth } = useApp();
  const byUser = auth?.mode === 'users';
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  async function login() {
    setBusy(true);
    setError(null);
    try {
      await api.login(password, byUser ? username : undefined);
      await refresh();
    } catch (e) {
      setError(e instanceof Error ? e.message : 'No se pudo entrar');
    } finally {
      setBusy(false);
    }
  }
  return (
    <div className="page" style={{ maxWidth: 420, margin: '80px auto' }}>
      <div className="panel">
        <div className="brand" style={{ margin: '0 0 18px' }}>
          <span>
            bal<span>ance</span>
          </span>
        </div>
        <h2>Entrar al hogar</h2>
        <p className="muted">{byUser ? 'Cada persona entra con su usuario y ve sus propias novedades.' : 'Acceso privado con la contraseña común del hogar (BALANCE_PASSWORD).'}</p>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            void login();
          }}
        >
          {byUser ? (
            <label>
              Usuario
              <input autoComplete="username" autoCapitalize="none" value={username} onChange={(e) => setUsername(e.target.value)} autoFocus />
            </label>
          ) : null}
          <label>
            Contraseña
            <input type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} autoFocus={!byUser} />
          </label>
          {error ? (
            <div className="error" role="alert">
              {error}
            </div>
          ) : null}
          <button type="submit" className="button primary" disabled={busy || !password || (byUser && !username)}>
            Entrar
          </button>
        </form>
      </div>
    </div>
  );
}
